<template>
  <button
    type="button"
    @click="emit('delete')"
    :aria-label="props.ariaLabel"
    class="mini-cart__delete-btn relative"
    :disabled="props.loading"
  >
    <IconLoading v-if="props.loading" class="left-1/2 -translate-x-1/2 w-4 h-4 absolute"/>
    <span class="sr-only">{{ props.screenReaderText }}</span>
    <IconDelete v-if="!props.loading" />
  </button>
</template>

<script setup>
import IconDelete from './mini-cart--icon-delete.vue'
import IconLoading from './mini-cart--icon-loading.vue'

// Props
const props = defineProps({
  ariaLabel: {
    type: String,
    default: 'Remove'
  },
  screenReaderText: {
    type: String,
    default: 'delete'
  },
  loading: {
    type: Boolean,
    default: false
  }
})

// Emits
const emit = defineEmits(['delete'])
</script>
